import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { ClassRoomSelectionHistoryEntryDto } from "./types.ts";

const GetClassRoomSelectionHistoryQuery = gql`
  query getClassRoomSelectionHistory($classRoomId: String!) {
    getClassRoomSelectionHistory(classRoomId: $classRoomId) {
      strategyName
      selectedTeacherId
      assignedAt
      candidates {
        teacherId
        reviewAvg
        reviewCount
        wasSelected
        weeklyCap {
          tier
          maxPercentOfWeeklyAvailability
          offeredSlots
          assignedClassRooms
          maxAssignableClassRooms
          hasBeenReached
        }
      }
    }
  }
`;

type QueryResult = {
  getClassRoomSelectionHistory: ClassRoomSelectionHistoryEntryDto[];
};

export function useClassRoomSelectionHistory() {
  const [fetch, { data, loading }] = useLazyQuery<QueryResult>(
    GetClassRoomSelectionHistoryQuery,
    { fetchPolicy: "cache-and-network" },
  );

  const fetchHistory = useCallback(
    (classRoomId: string) => fetch({ variables: { classRoomId } }),
    [fetch],
  );

  return {
    fetchHistory,
    history: data?.getClassRoomSelectionHistory ?? null,
    loading,
  };
}
